import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useNotificationBadge } from '@/hooks/useNotificationBadge';

interface NotificationButtonProps {
  className?: string;
}

export function NotificationButton({ className = '' }: NotificationButtonProps) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { unreadCount } = useNotificationBadge();

  const handleClick = () => {
    if (!user) {
      navigate('/login');
      return;
    }
    navigate('/buyer/notifications');
  };

  return (
    <button
      className={`relative p-0 bg-transparent border-none cursor-pointer active:opacity-70 transition-opacity ${className}`}
      onClick={handleClick}
      aria-label="알림"
    >
      <img
        src="/icons/common_home_notification_button_default.svg"
        alt="알림"
        className="w-6 h-6"
      />
      {user && unreadCount > 0 && (
        <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
